'use client';

import SettingsIcon from '@mui/icons-material/Settings';
import { alpha, Box, Button } from '@mui/material';
import { FlexRow, StackRow } from '@ocodelib/mui';
import clsx from 'clsx';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import { BootstrapInput } from '../../components/BootstrapInput';
import { LoginButton } from '../../components/LoginButton';
import { LogoLinkButton } from '../../components/LogoLinkButton';

interface Props {
  title?: string;
  className?: string;
  backLink?: string;
}

export function WorkspaceTopbar(props: Props) {
  const { className, title } = props;
  const rootRef = useRef<HTMLElement | null>(null);

  return (
    <FlexRow.Between
      alignItems="center"
      ref={rootRef}
      className={clsx('WorkspaceTopbar-root', className)}
      sx={{
        position: 'relative',
        bgcolor: 'primary.main',
        height: 52,
        color: 'primary.contrastText',
        boxShadow: 'none',
        '& .MuiButton-root': {
          color: 'primary.contrastText',
          '&:hover': {
            color: (theme) => alpha(theme.palette.primary.contrastText, 0.85),
          },
        },
      }}
    >
      <StackRow
        alignItems="center"
        spacing={1}
        sx={{
          '& .MuiButton-root': {
            color: 'primary.contrastText',
            '&:hover': {
              color: (theme) => alpha(theme.palette.primary.contrastText, 0.85),
            },
          },
        }}
      >
        <LogoLinkButton href={props.backLink || '/coding/list'} title="" />
        <BootstrapInput defaultValue="새 프로젝트" size="small" autoComplete="off" />
        <Button
          component="div"
          onClick={() => {
            toast.warn('지원 예정');
          }}
        >
          저장
        </Button>
      </StackRow>
      <FlexRow alignItems="center">
        <Button
          component="div"
          startIcon={<SettingsIcon />}
          onClick={() => {
            toast.warn('지원 예정');
          }}
        >
          설정
        </Button>
        <Button
          component="div"
          onClick={() => {
            toast.warn('지원 예정');
          }}
        >
          새로 만들기
        </Button>
        <Button
          component="div"
          onClick={() => {
            toast.warn('지원 예정');
          }}
        >
          불러오기
        </Button>
        <Box
          sx={{
            position: 'relative',
            '&::before': {
              position: 'absolute',
              content: '""',
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
              height: 16,
              width: '1px',
              bgcolor: '#fff4',
            },
          }}
        >
          <LoginButton />
        </Box>
      </FlexRow>
    </FlexRow.Between>
  );
}
